/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureDiskSettings {
  /**
  * Disk name.
  */
  'name': string;
  /**
  * Disk type.
  */
  'type': string;
  /**
  * Disk tier.
  */
  'tier': string;
  /**
  * Hyper-V generation of the disk. When restoring, defaults to the original Hyper-V generation captured by the snapshot. 
  */
  'hyperVGeneration'?: string;
  /**
  * Size of the disk, in bytes. When restoring, defaults to the original disk size captured by the snapshot. 
  */
  'sizeBytes'?: number;
  /**
  * Tags to apply to the restored disk as key-value pairs, where key and value are both strings. If not provided, defaults to an empty object, with no tags applied.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "tier",
      "baseName": "tier",
      "type": "string",
      "format": ""
    },
    {
      "name": "hyperVGeneration",
      "baseName": "hyperVGeneration",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDiskSettings.attributeTypeMap;
  }

  public constructor() {
  }
}

